import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'app-x-placeholder-fixed-loader',
  standalone: true,
  imports: [],
  templateUrl: './x-placeholder-fixed-loader.component.html',
  styleUrl: './x-placeholder-fixed-loader.component.less'
})
export class XPlaceholderFixedLoaderComponent {
  @HostBinding('style.width') @Input() width: string = '24px';
  @HostBinding('style.height') @Input() height: string = '100%';
}
